import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mt-8 pa-2 access-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mx-auto mt-16 py-2 px-6",
        "max-width": "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Sign in ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.usernameInput,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usernameInput) = $event)),
                name: "username",
                label: "Username",
                type: "text",
                placeholder: "Username",
                variant: "outlined",
                required: "",
                rules: _ctx.emailRules
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.passwordInput,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordInput) = $event)),
                name: "password",
                label: "Password",
                type: "password",
                placeholder: "password",
                required: "",
                variant: "outlined",
                rules: _ctx.passwordRules,
                onKeydown: _withKeys(_ctx.signin, ["enter"])
              }, null, 8, ["modelValue", "rules", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _ctx.signin,
                text: "Go"
              }, null, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.rememberInput,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberInput) = $event)),
                label: "Remember me",
                density: "compact",
                "hide-details": "",
                class: "mt-0",
                onKeydown: _withKeys(_ctx.signin, ["enter"])
              }, null, 8, ["modelValue", "onKeydown"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _cache[5] || (_cache[5] = _createTextVNode("If you don't have an account, you can ")),
          _createVNode(_component_router_link, { to: "/register" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("register here")
            ])),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createTextVNode(". "))
        ])
      ])
    ]),
    _: 1
  }))
}